var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandardLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "450px",
    height: "203px",
    viewBox: "0 0 450 203",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo e-invest white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 279.643939 0 279.643939 202.9996 0 202.9996"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 203 450.195 203 450.195 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-e-invest-white",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(-0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0, 0.0004)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.3587,154.343 L278.6297,134.186 C280.9667,129.598 279.1257,125.845 274.5387,125.845 L132.0467,125.845 C127.4587,125.845 121.7927,129.598 119.4557,134.186 L109.1847,154.343 C106.8477,158.931 108.6887,162.684 113.2757,162.684 L255.7677,162.684 C260.3557,162.684 266.0217,158.931 268.3587,154.343 M221.0927,108.468 L231.0097,89.005 C233.3467,84.418 231.5057,80.664 226.9187,80.664 L131.6927,80.664 C127.1047,80.664 121.4387,84.418 119.1017,89.005 L109.1847,108.468 C106.8477,113.055 108.6887,116.809 113.2757,116.809 L208.5017,116.809 C213.0897,116.809 218.7557,113.055 221.0927,108.468 M268.3587,63.287 L278.6297,43.13 C280.9667,38.542 279.1257,34.789 274.5387,34.789 L132.0467,34.789 C127.4587,34.789 121.7927,38.542 119.4557,43.13 L109.1847,63.287 C106.8477,67.875 108.6887,71.628 113.2757,71.628 L255.7677,71.628 C260.3557,71.628 266.0217,67.875 268.3587,63.287 M168.5837,109.491 C167.3287,121.257 164.2847,131.956 159.7867,141.623 C150.7297,161.082 136.7027,173.228 130.5277,178.535 C124.5027,183.714 118.9797,187.474 114.9037,190.014 C110.1447,192.276 105.3857,194.539 100.6267,196.802 C95.9517,198.977 91.0587,200.825 86.0577,202.565 L85.9487,202.565 L84.5347,203 C82.4687,202.456 80.5117,201.804 78.5547,201.042 C38.6507,186.146 5.5967,156.137 0.5947,109.6 C-1.5793,88.941 2.7697,37.62 4.6177,17.614 C4.8357,12.939 7.9887,8.916 12.5557,7.828 C36.2587,2.827 60.3967,0.217 84.6437,0 C108.8907,0.108 133.0287,2.827 156.7317,7.828 C161.1897,8.916 164.4517,12.939 164.6697,17.614 C166.5177,37.512 170.8667,88.941 168.5837,109.491",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "250.264 117.313 259.084 117.313 259.084 77.025 250.264 77.025"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "267.796 77.0253 276.67 77.0253 293.548 102.7223 293.656 102.7223 293.656 77.0253 301.823 77.0253 301.823 117.3133 293.656 117.3133 276.071 91.3983 275.963 91.3983 275.963 117.3133 267.796 117.3133"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "306.8907 77.0253 315.8727 77.0253 325.0747 105.8263 325.1837 105.8263 334.7107 77.0253 343.0407 77.0253 329.1587 117.4763 320.7737 117.4763"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "348.1075 77.0253 375.5465 77.0253 375.5465 84.4293 356.9815 84.4293 356.9815 93.0863 370.4295 93.0863 370.4295 100.1093 356.9815 100.1093 356.9815 110.1273 376.5275 110.1273 376.5275 117.3133 348.1075 117.3133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.3956,108.1669 L387.0916,104.1919 C389.3246,108.6029 393.3536,111.0529 397.9806,111.0529 C402.0646,111.0529 405.0036,109.5279 405.0036,106.4249 C405.0036,103.3759 402.1186,102.0689 396.8376,100.5999 C389.6506,98.5849 382.1376,96.7339 382.1376,88.2949 C382.1376,80.7819 388.0176,76.2629 396.6736,76.2629 C404.9496,76.2629 409.8496,80.2369 412.6806,84.5389 L406.5286,89.2209 C404.4056,85.7909 400.5396,83.5039 396.6196,83.5039 C392.8636,83.5039 390.7936,85.1379 390.7936,87.5329 C390.7936,90.7449 393.7896,91.8889 399.0696,93.3579 C406.1476,95.2639 413.6606,97.4959 413.6606,105.8259 C413.6606,112.3049 408.7606,118.0759 397.5446,118.0759 C388.8336,118.0759 383.3896,113.9379 380.3956,108.1669",
    id: "Fill-9",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "429.2892 84.4296 417.3122 84.4296 417.3122 77.0256 450.1952 77.0256 450.1952 84.4296 438.1642 84.4296 438.1642 117.3136 429.2892 117.3136"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "232.208 95.8237 246.526 95.8237 243.53 101.7047 229.212 101.7047"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardLogo);
export default __webpack_public_path__ + "static/media/STANDARD_logo.baa7d717de2f61413fcac6a0493ad69f.svg";
export { ForwardRef as ReactComponent };